export default {
  LightGray: '#d3d0ce',
  Gray: '#787779',
  Blue: '#1a345d',
  Green: '#96c93c',
  LightBlue: '#99caea',
  Red: '#ff0000',
}
